export default {
    state: {
        permissionInfo: {
            scode: '',
            smsg: ''
        }, //权限信息
        showMask: false,
        contentMessage: '',
    },
    //同步更新数据
    mutations: {
        updatePermissionInfo(state, data) {
            state.permissionInfo = data
        },
        toggleShowMask(state, data) {
            state.showMask = data
        },
        updateContentMessage(state, data) {
            state.contentMessage = data
        },
    }
}



// WEBPACK FOOTER //
// ./src/store/checkAgent.js